var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24f7bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24c4fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 949.87,
    x2: 974.39,
    y1: 518.014,
    y2: 544.657,
    gradientTransform: "translate(-969.568 491.682) scale(1.02524)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1020.362)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    y: 1020.362,
    fill: "url(#b)",
    rx: 6.763,
    ry: 6.763
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb"
    },
    fill: "#fff",
    d: "M16 8.5c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.364-7.5-7.5-7.5zm0 1c3.596 0 6.5 2.904 6.5 6.5s-2.904 6.5-6.5 6.5A6.492 6.492 0 0 1 9.5 16c0-3.596 2.904-6.5 6.5-6.5zm-.188 1.5c-.377.03-.754.14-1.093.344A2.53 2.53 0 0 0 13.563 14a.5.5 0 0 0 .968-.219 1.463 1.463 0 0 1 .688-1.562 1.489 1.489 0 0 1 1.719.125c.491.402.682 1.057.468 1.656-.214.599-.77 1-1.406 1a.5.5 0 0 0-.5.625v2.969a.5.5 0 1 0 1 0v-2.657a2.485 2.485 0 0 0 1.844-1.593c.354-.994.066-2.113-.75-2.781A2.505 2.505 0 0 0 15.812 11zm.094 9.063a.5.5 0 0 0-.406.5.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5.5.5 0 0 0-.094 0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(0 1020.362)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.e57b1d7fedaebec2a94bd378d80234f2.svg";
export { ForwardRef as ReactComponent };